import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Search = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7 20.3002L18 16.6002C21.1 12.7002 20.5 7.00024 16.6 3.90024C12.7 0.800239 6.99999 1.50024 3.89999 5.30024C0.799994 9.20024 1.49999 14.9002 5.29999 18.0002C8.59999 20.6002 13.3 20.6002 16.6 18.0002L20.3 21.7002C20.7 22.1002 21.3 22.1002 21.7 21.7002C22.1 21.3002 22.1 20.7002 21.7 20.3002ZM11 18.0002C7.09999 18.0002 3.99999 14.9002 3.99999 11.0002C3.99999 7.10024 7.09999 4.00024 11 4.00024C14.9 4.00024 18 7.10024 18 11.0002C18 14.9002 14.9 18.0002 11 18.0002Z"
      fill="currentColor"
    />
  </svg>
)

export default Search
